import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';

interface ThemeToggleProps {
  /**
   * 'onColor' — for the blue-gradient app bar (white icon, white/10 hover).
   * 'neutral' — for plain headers/toolbars (bordered icon button). Default.
   */
  variant?: 'onColor' | 'neutral';
  className?: string;
}

const ON_COLOR_CLS =
  'inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-white/90 transition-colors duration-150 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/60 sm:min-h-0 sm:min-w-0 sm:h-9 sm:w-9';

const NEUTRAL_CLS =
  'inline-flex h-11 w-11 items-center justify-center rounded-lg border border-gray-300 text-gray-600 transition-colors duration-150 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 sm:h-8 sm:w-8';

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  variant = 'neutral',
  className,
}) => {
  const { theme, toggle } = useTheme();
  const base = variant === 'onColor' ? ON_COLOR_CLS : NEUTRAL_CLS;
  // Show the icon of the mode you'd switch TO.
  const Icon = theme === 'dark' ? Sun : Moon;
  return (
    <button
      type="button"
      aria-label="Toggle dark mode"
      className={className ? `${base} ${className}` : base}
      onClick={toggle}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
};
